import { useEffect, useRef, useState } from 'react';
import { Loader2 } from 'lucide-react';

/* A cold pod serves this page from the CDN while its API is still loading, so
   for a few seconds every call 503s. Without a word on screen that reads as
   "HiroJet is not loading" — which is exactly what the owner reported in June
   2026. The api layer retries those 503s and fires `hj:api-starting`; this says
   so, and gets out of the way the moment a call succeeds. */
export const StartingBanner = () => {
  const [show, setShow] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    const onStarting = () => {
      setShow(true);
      clearTimeout(timer.current);
      // If nothing 503s for four seconds, the API is up — stop saying otherwise.
      timer.current = setTimeout(() => setShow(false), 4000);
    };
    window.addEventListener('hj:api-starting', onStarting);
    return () => {
      window.removeEventListener('hj:api-starting', onStarting);
      clearTimeout(timer.current);
    };
  }, []);

  if (!show) return null;

  return (
    <div data-testid="api-starting-banner"
      className="fixed top-0 inset-x-0 z-[100] flex items-center justify-center gap-2
        bg-amber-500/15 border-b border-amber-500/30 backdrop-blur-sm px-4 py-2">
      <Loader2 className="w-3.5 h-3.5 text-amber-300 animate-spin shrink-0" />
      <p className="text-caption text-amber-200">
        HiroJet is starting up — this takes a few seconds after a new release. Retrying.
      </p>
    </div>
  );
};

export default StartingBanner;
